/* eslint-disable react/prop-types */
import React from 'react';
import { Link } from 'react-router-dom';
import { Box } from 'rebass';

import Truncator from '../../../components/Truncator';
import CatalogTypeBadge from '../../catalogTypes/CatalogTypeBadge';

import ColumnFilterSort from '../../../components/tableServerSide/ColumnFilterSort';

import { rangeFormatter, formatToDateAndTime } from '../../../util/date';
import { escapeSpecialCharsInFilterInput } from '../../util';

import { truncatorProps } from '../../constants';

export const columnSortModifiersAccountCatalogs = {
  id: null,
  name: null,
  catalogTypes: { colId: 'catalogTypeName' },
  seasons: { disabled: true },
  atOnceDate: { colId: 'atOnceStart' },
  futuresDate: { colId: 'futuresStart' },
  forecastDate: { colId: 'forecastStart' },
  defaultSort: {}
};

export const columnFilterModifiersAccountCatalogs = {
  id: { expression: 'Like' },
  name: { expression: 'Like', value: escapeSpecialCharsInFilterInput },
  catalogTypes: { colId: 'catalogTypeName', expression: 'Like', value: escapeSpecialCharsInFilterInput },
  seasons: {
    expression: 'Includes',
    value: input => {
      // correct the input season format. For example from SP22 to SP2022
      if (/^[a-zA-Z]{2}\d{2}$/.test(input)) {
        const season = input.substr(0, 2);
        const year = input.substr(2);
        return `${season}20${year}`;
      }
      return input;
    }
  },
  atOnceDate: { colId: 'atOnceStart' },
  futuresDate: { colId: 'futuresStart' },
  forecastDate: { colId: 'forecastStart' }
};

export const getAccountCatalogColumns = () => {
  return [
    {
      Header: tableInstance => <ColumnFilterSort header='Catalog ID' tableInstance={tableInstance} align='right' />,
      width: 130,
      id: 'id',
      accessor: originalRow => ({ id: originalRow.id, shortId: originalRow.shortId }),
      Cell: ({ value: { shortId, id } }) => (
        <Link to={`/catalogs/edit/${id}`} className='catalogs__link'>
          {shortId || id?.substr(0, 7)}
        </Link>
      )
    },
    {
      Header: tableInstance => <ColumnFilterSort header='Catalog Name' tableInstance={tableInstance} />,
      width: 350,
      accessor: 'name',
      Cell: ({ value }) =>
        value?.split?.(' ')?.length > 1 ? (
          value
        ) : (
          <Box>
            <Truncator value={value} {...truncatorProps} />
          </Box>
        )
    },
    {
      Header: tableInstance => <ColumnFilterSort header='Catalog Type' tableInstance={tableInstance} />,
      width: 350,
      accessor: 'catalogTypes',
      Cell: ({ value }) => (
        <section className='d-sm-flx flx-wr-sm-w'>
          {value?.map(catalogType => (
            <CatalogTypeBadge key={catalogType.id} catalogType={catalogType} />
          ))}
        </section>
      )
    },
    {
      Header: tableInstance => <ColumnFilterSort header='Season' tableInstance={tableInstance} />,
      width: 120,
      accessor: 'seasons',
      Cell: ({ value }) => {
        const trimmedValues = value?.map(i => {
          return i?.slice(0, 2) + i?.slice(4);
        });
        let finalValue = '';
        finalValue =
          trimmedValues.length === 0
            ? ''
            : `${trimmedValues[0]}${trimmedValues.length > 1 ? ` - ${trimmedValues[trimmedValues.length - 1]}` : ''}`;

        return finalValue;
      }
    },
    {
      Header: tableInstance => <ColumnFilterSort header='At-Once Dates' tableInstance={tableInstance} />,
      width: 150,
      accessor: ({ atOnceStart, atOnceEnd }) => ({ atOnceStart, atOnceEnd }),
      id: 'atOnceDate',
      Cell: ({ value: { atOnceStart, atOnceEnd } }) => rangeFormatter({ start: atOnceStart, end: atOnceEnd })
    },
    {
      Header: tableInstance => <ColumnFilterSort header='Futures Dates' tableInstance={tableInstance} />,
      width: 150,
      accessor: ({ futuresStart, futuresEnd }) => ({ futuresStart, futuresEnd }),
      id: 'futuresDate',
      Cell: ({ value: { futuresStart, futuresEnd } }) => rangeFormatter({ start: futuresStart, end: futuresEnd })
    },
    {
      Header: tableInstance => <ColumnFilterSort header='Forecast Dates' tableInstance={tableInstance} />,
      width: 160,
      accessor: ({ forecastStart, forecastEnd }) => ({ forecastStart, forecastEnd }),
      id: 'forecastDate',
      Cell: ({ value: { forecastStart, forecastEnd } }) => rangeFormatter({ start: forecastStart, end: forecastEnd })
    },
    {
      Header: tableInstance => <ColumnFilterSort header='Last Indexed' tableInstance={tableInstance} />,
      width: 160,
      accessor: 'indexedTimestamp',
      Cell: ({ value }) => formatToDateAndTime(value)
    }
  ];
};
